import type { FeedbackState } from './types';

const initialState: FeedbackState = {
  consecutiveTime: 0,
  feedback: undefined,
  feedbackSentTime: undefined,
  isEligibleForSurvey: false,
  lastSeen: new Date(),
  modalShownTime: undefined,
  rating: undefined,
};

export default initialState;
